module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-normal.fa4bb1c5.png";